export default "__VITE_ASSET__Dr0uO926__"